import React, { useState, useEffect, useMemo } from 'react';
import Highcharts from 'highcharts';
import Tooltip from '@material-ui/core/Tooltip';
import HelpIcon from '@material-ui/icons/HelpOutlineOutlined';
import ReactHighcharts from 'react-highcharts';

const utils = require('../../components/utils');
const SOURCE = '';
const LOADING = 'Loading...';
const REVENUE_COLOR = '#a0ce4e';
const BORDER_COLOR = '#666666';
const baseUrl = `${window.nobid_endpoint}/adquality_reports_report_optimizer`;

const AuctionOptimizerComponent = ({revs, params, setOptimizerData, submit}) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});

  let config = useMemo(() => ({
    chart: {
      id: 'OptimizerChart',
      renderTo: 'container',
      zoomType: 'x',
      backgroundColor: 'none',
      borderColor: BORDER_COLOR,
      borderWidth: 1
    },
    title: {
      text: '% OPTIMIZED REQUESTS AND REVENUE',
      style: { color: '#ffffff', fontSize: '12px', fontWeight: 600 }
    },
    subtitle: { text: SOURCE },
    xAxis: {
      type: 'datetime',
      labels: {
        format: '{value:%e-%b}',
        style: { color: '#ffffff', fontFamily: 'Roboto, Helvetica, Arial, sans-serif', fontSize: '11px', fontWeight: 600 }
      },
      crosshair: true,
      gridLineWidth: 0
    },
    plotOptions: {
      series: { marker: { enabled: true } }
    },
    yAxis: [{
      labels: {
        style: { color: '#ffffff' }
      },
      title: {
        text: '$Revenue',
        style: { color: '#ffffff' }
      }
      , min: 0
      , gridLineWidth: 0,
      stackLabels: {
        enabled: true
      }
    },
    {
      labels: {
        format: '{value}%',
        style: { color: '#ffffff' }
      },
      max: 100,
      title: {
        text: '%Optimized',
        style: { color: '#ffffff' }
      }
      , min: 0
      , gridLineWidth: 0,
      stackLabels: {
        enabled: true
      }
    }
    ],
    series: [data, {
      name: 'Revenue',
      shadow: true,
      color: "#49b27b",
      yAxis: 0,
      type: 'line',
      data: revs,
    }],
    legend: { enabled: false, itemStyle: { color: '#ffffff' } }
    ,credits: { enabled: false }
  }), [data, revs]);

  const updateState = (results) => {
    const data = [];
    let totalAccepted = 0;
    let totalOptimized = 0;
    let deviceGroupsObj = {};
    let dateGroupsObj = {};

    if (results?.data?.length > 0) {
      deviceGroupsObj = results.data.reduce((hash, obj) => {
        let key = !obj.device || obj.device ==='UNKNOWN' ? 'OTHER' : obj['device'];
        let newObj = {}; 
        if (hash[key]) {
          newObj.accepted = hash[key].accepted + obj.accepted;
          newObj.optimized = hash[key].optimized + obj.optimized;
        } else {
          newObj = { accepted: obj.accepted, optimized: obj.optimized }
        }; 
        return { ...hash, [key]: newObj }
      }, {});

      dateGroupsObj = results.data.reduce((hash, obj) => {
        let key = obj['date'];
        let newObj = {date: key}; 
        if (hash[key]) {
          newObj.accepted = hash[key].accepted + obj.accepted;
          newObj.optimized = hash[key].optimized + obj.optimized;
        } else {
          newObj = { date: key, accepted: obj.accepted, optimized: obj.optimized }
        }; 
        return { ...hash, [key]: newObj }
      }, {});



      for (const dt of Object.values(dateGroupsObj)) {
        const pct = 100 * Number(dt.optimized) / (Number(dt.accepted) + Number(dt.optimized));
        totalAccepted += Number(dt.accepted);
        totalOptimized += Number(dt.optimized);
        data.push({ x: (new Date(dt.date)).getTime(), y: utils.roundDouble(pct, 2) });
      }
    }

    setOptimizerData({
      totalAccepted: totalAccepted,
      totalOptimized: totalOptimized,
      devicesData: deviceGroupsObj
    });

    const seriesObj = {
      name: '%Optimized',
      shadow: true,
      color: '#a0ce4e',
      borderColor: '#a0ce4e',
      type: 'column',
      borderRadius: 0,
      animation: Highcharts.svg,
      yAxis: 1,
    }
    seriesObj.data = data;
    setData(seriesObj)
    setLoading(false);
  }

  const getData = () => {
    setLoading(true);
    config.subtitle.text = LOADING;
    config.series = [];

    let url = `${baseUrl}?${params.join('&')}&show=date&show=device`;
    let options = { headers: new Headers() };
    options.headers.set('accept', 'application/json');
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, options).then((response) => {
      config.subtitle.text = SOURCE;
      return response.json();
    }).then((results) => {
      updateState(results);
    });
  }

  useEffect(() => { if (submit) getData() }, [submit, revs.length]);
 
  return (
    <div style={{position: 'relative'}}>
      <Tooltip title={
        <React.Fragment>
          Optimized Requests are requests that the NoBid Auction Optimizer technology filters out from the auction.
        </React.Fragment>
      } style={{position: 'absolute', right: 0, margin: '10px', zIndex: 1}}>
        <HelpIcon/>
      </Tooltip>
      <ReactHighcharts config={config} />
    </div>
  )
}

export default AuctionOptimizerComponent;
